import { IconButton } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { SentimentType } from '../../../components/AIAssistant/AIFeedbackModal/constants';
import type { AiChatStore } from '../store';

export const PositiveFeedbackButton = observer(
	({ id, store }: { id: string; store: AiChatStore }) => {
		const message = store.getMessage(id);

		if (
			message?.prompt.user_feedback_raw?.sentiment === SentimentType.Positive
		) {
			return (
				<IconButton
					iconName="thumbUpFilled"
					variant="tertiary"
					tooltip="Positive feedback for this prompt already submitted"
				/>
			);
		}

		return (
			<IconButton
				iconName="thumbUp"
				variant="tertiary"
				onClick={() => store.showPositiveFeedbackModal(id)}
				tooltip="Good response"
			/>
		);
	}
);
